import { ReactNode } from "react";

import { ReusableViewReferenceFields } from "../../types/PageInterfaces";
import SectionRenderer from "../Records/SectionRenderer";

interface Props {
  section: any;
  detailViewLayoutID: string;
  record: any;
  module: any;
  className?: string;
  headerOptions?: ReactNode;
  reusableViewReferenceFields?: ReusableViewReferenceFields;
}

// The section prop currently expects an object containing a Title, Description, and Fields properties.
// Fields should hold an array of objects containing a ColSpan, Field. Field stores the APIName of the field.
const RecordDetailWidget = ({
  section,
  detailViewLayoutID,
  record,
  module,
  className = "",
  headerOptions,
  reusableViewReferenceFields,
}: Props) => {
  return (
    <div className={className ?? "mx-5 px-3"}>
      <SectionRenderer
        section={section}
        detailViewLayoutID={detailViewLayoutID}
        record={record}
        module={module}
        headerOptions={headerOptions}
        reusableViewReferenceFields={reusableViewReferenceFields}
      />
    </div>
  );
};

export default RecordDetailWidget;
